module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av674-4f44c29f03ecd6a7c697663314116a9c.jpg";